module.exports = "../study/imgs/maps/Tokyo/S8/Hazard/Beach/Tokyo_Beach_GFDL_RCP26_End.png";